import gsap from 'gsap';

export default function initPromoPanel() {
  const desktop = window.matchMedia('(min-width: 768px)');
  const panel = document.querySelector('.promo-panel');
  if (!panel) return;

  const close = panel.querySelector('.close');
  if (!close) return;

  const holder = panel.querySelector('.panel-holder');

  const moveCloser = (isDesktop) => {
    if (isDesktop) {
      holder.append(close);
    } else {
      holder.prepend(close);
    }
  };

  moveCloser(desktop.matches);
  desktop.addEventListener('change', (e) => moveCloser(e.matches));

  close.addEventListener('click', () => {
    gsap.to(panel, { height: 0, paddingTop: 0, paddingBottom: 0, overflow: 'hidden', duration: 0.4, onComplete() {
      panel.remove();
    }});
  });
}
